export enum ReportStatusEnum {
  Open = 0,
  Closed = 1,
  TRANSFERRED_TO_TASK = 2,
}
